<script setup lang="ts">
import type { Canvass } from "@/canvasses/types";
import SafeHtml from "@/components/SafeHtml.vue";

defineProps<{
  canvass: Canvass;
}>();
</script>

<template>
  <section class="box container container-md conversation-guide">
    <article class="card">
      <SafeHtml :html="canvass.conversationGuide" />
    </article>
  </section>
</template>

<style>
.conversation-guide {
  a,
  a:visited {
    color: revert;
  }

  ul,
  ol,
  li {
    margin: revert;
    padding: revert;
  }
}
</style>
